import React, { useEffect, useMemo, useState } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useNavigate, useLocation } from "react-router-dom";
import "./AddRole.css";
import { toast } from "react-toastify";
import { get, post, patch } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";

const AddRole = () => {
  const navigate = useNavigate();
  const { type, data } = useLocation().state || {};
  const [roleName, setRoleName] = useState(data?.name || "");
  const [permissionList, setPermissionList] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState(
    data?.permissions?.map((p) => (typeof p === "object" ? p.id : p)) || []
  );

  const fetchPermission = async () => {
    try {
      let res = await get(URLS.ROLEPERMISSION);

      if (res?.status === "success" || res) {
        setPermissionList(res || []);
      } else {
        setPermissionList([]);
      }
    } catch (error) {
      console.error("Error fetching permission list:", error);
    }
  };

  useEffect(() => {
    fetchPermission();
  }, []);

  console.log("permissionList", permissionList);

  // Process permissionList to get unique modules and permission types
  const modules = useMemo(() => {
    const uniqueModules = new Set();
    console.log("partsparts", permissionList);

    permissionList?.forEach((p) => {
      const parts = p?.code.split("-");

      if (parts.length >= 3) {
        uniqueModules.add(parts.slice(2).join("-"));
      }
    });
    console.log("uniqueModules", uniqueModules);

    return Array.from(uniqueModules);
  }, [permissionList]);

  const permissionTypes = useMemo(() => {
    const uniqueTypes = new Set();
    permissionList?.forEach((p) => uniqueTypes.add(p?.name));
    // Sort to maintain a consistent order if possible, or keep as is
    return Array.from(uniqueTypes);
  }, [permissionList]);

  const handlePermissionToggle = (id) => {
    setSelectedPermissions((prev) =>
      prev.includes(id) ? prev.filter((pId) => pId !== id) : [...prev, id]
    );
  };

  const handleModuleToggle = (moduleName) => {
    const modulePermissionIds = permissionList
      ?.filter((p) => p.code.endsWith(moduleName))
      ?.map((p) => p.id);

    const allSelected = modulePermissionIds.every((id) =>
      selectedPermissions.includes(id)
    );

    if (allSelected) {
      // Deselect all in this module
      setSelectedPermissions((prev) =>
        prev.filter((id) => !modulePermissionIds.includes(id))
      );
    } else {
      // Select all in this module
      setSelectedPermissions((prev) => [
        ...new Set([...prev, ...modulePermissionIds]),
      ]);
    }
  };

  const handleSelectAll = () => {
    const allIds = permissionList?.map((p) => p.id);
    if (selectedPermissions.length === allIds.length) {
      setSelectedPermissions([]);
    } else {
      setSelectedPermissions(allIds);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let role = roleName.trim();
    if (!role || selectedPermissions?.length === 0) {
      toast.error(
        !role ? "Please Add Role Name" : "Atleast one Permission is Required "
      );
      return;
    }
    let payload = {
      name: role,
      code: role?.replaceAll(" ", "_"),
    };
    payload[`permission${type === "edit" ? "s" : "_ids"}`] =
      selectedPermissions;
    let method = type === "edit" ? patch : post;
    let url = type === "edit" ? `${URLS.EDIT_ROLE}${data?.id}/` : URLS.ADD_ROLE;
    let res = await method(url, payload);
    if (res?.id && res?.permissions?.length > 0) {
      toast.success(res?.message ?? "Roles Updated Successfully");
      navigate(-1);
    }
  };
  console.log("modulesmodules", permissionList);

  return (
    <>
      <PageHeader
        title={type === "edit" ? "Edit Role" : "Add Role"}
        showBackButton={true}
        onBackClick={() => navigate(-1)}
        buttonText={
          selectedPermissions.length === permissionList?.length
            ? "Deselect All"
            : "Select All"
        }
        onButtonClick={handleSelectAll}
      />
      <div className="add-role-container">
        <form onSubmit={handleSubmit}>
          <div>
            <div className="role-name-section">
              <label htmlFor="roleName">Role Name</label>
              <input
                type="text"
                id="roleName"
                className="role-name-input"
                placeholder="Admin"
                value={roleName}
                onChange={(e) => setRoleName(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 d-flex justify-content-between align-items-center">
              <h2 className="permissions-title">Permissions</h2>
              <button
                onClick={() => handleSelectAll()}
                style={{ backgroundColor: "#7c54a9", borderColor: "#7c54a9" }}
                className="btn btn-primary"
              >
                Select All
              </button>
            </div>
          </div>
          <div className="permissions-section">
            <div className="permissions-grid-container">
              {modules.map((module) => (
                <div key={module} className="module-card">
                  <div className="module-card-header">
                    <h3>{module.replace(/_/g, " ")}</h3>
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={permissionList
                          ?.filter((p) => p.code.endsWith(module))
                          ?.every((p) => selectedPermissions.includes(p.id))}
                        onChange={() => handleModuleToggle(module)}
                      />
                      <span className="slider"></span>
                    </label>
                  </div>
                  <div className="module-permissions-list">
                    {permissionTypes.map((type) => {
                      const permission = permissionList?.find(
                        (p) => p.name === type && p.code.endsWith(module)
                      );
                      if (!permission) return null;
                      return (
                        <div
                          key={`${module}-${type}`}
                          className="permission-row"
                        >
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={selectedPermissions.includes(
                                permission.id
                              )}
                              onChange={() =>
                                handlePermissionToggle(permission.id)
                              }
                            />
                            <span className="slider"></span>
                          </label>
                          <span className="permission-name">{type}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="submit-section">
            <button type="submit" className="btn-submit">
              Submit
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddRole;
